/**
 * Admin agent commands go through the authorized backend API.
 * The browser does not open a broker session. The public broker login
 * cannot publish commands or subscribe to another Agent's topics.
 */

import { sendAgentCommand } from '../../api/agentCommands';

const browserMqttDisabled = () => {
  throw new Error('Browser MQTT is disabled. Admin commands use the authorized API.');
};

export const initializeMqtt = async () => browserMqttDisabled();

export const getMqttInstance = async () => browserMqttDisabled();

export const decodeMqttPayload = payload => {
  try {
    if (typeof payload === 'string') return payload;
    if (typeof Buffer !== 'undefined' && payload instanceof Buffer) return payload.toString();
    if (payload instanceof Uint8Array) {
      let text = '';
      for (let i = 0; i < payload.length; i += 1) text += String.fromCharCode(payload[i]);
      return text;
    }
    if (payload && typeof payload.toString === 'function' && payload.toString !== Object.prototype.toString) {
      return payload.toString();
    }
    return String(payload);
  } catch (_) {
    return '';
  }
};

const commandIdFrom = response => response?.data?.commandId || response?.commandId || null;

export const subscribeToAgentStatus = async () => () => {};

export const subscribeToKnownAgents = async () => () => {};

export const subscribeToAgentResults = async () => () => {};

export const sendCommandToAgent = async (agentId, type, payload = {}) => {
  const response = await sendAgentCommand(agentId, {
    action: type,
    ...payload,
  });
  return commandIdFrom(response);
};

export const sendConfigToAgent = async (agentId, features = {}, settings = {}) => {
  const response = await sendAgentCommand(agentId, {
    action: 'update-config',
    config: {
      features,
      settings,
    },
  });
  return commandIdFrom(response);
};

export const broadcastToTenant = async () => browserMqttDisabled();

export default {
  initializeMqtt,
  getMqttInstance,
  subscribeToAgentStatus,
  subscribeToKnownAgents,
  subscribeToAgentResults,
  sendCommandToAgent,
  sendConfigToAgent,
  broadcastToTenant,
};
